<template>
  <div id="detail-treatment" class="modal-content bg-white rounded-4 p-3">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h5 class="text-semiBold">Detail Treatment</h5>
      <button class="btn close-popup p-0" type="button">
        <span class="icon-ico-close"></span>
      </button>
    </div>

    <div class="content-popup" v-if="data">
      <div class="d-flex align-items-center mb-3">
        <img :src="data.collectionImage?.[0] || '/img/user-3.jpg'" class="treatment rounded-2" />
        <div class="col ps-2">
          <h6 class="text-sm text-medium mb-1">{{ data.name }}</h6>
          <ul class="item-info list-unstyled mb-0">
            <li>
              <span class="text-xs text-medium">Durasi: {{ data.durationHours }} Jam {{ data.durationMinutes }} Menit</span>
            </li>
            <li>
              <span class="text-xs color-red-100 text-semiBold">{{ data.price | currency }}</span>
            </li>
          </ul>
        </div>
      </div>

      <hr />

      <h6 class="text-sm text-medium mb-2">Bahan yang Digunakan</h6>
      <div v-if="stockData.length" class="table-responsive">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Nama Bahan</th>
              <th>Penggunaan per Treatment</th>
              <th>Jumlah Stok</th>
              <th>Sisa Stok</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="stockItem in paginatedMaterials" :key="stockItem.id">
              <td>{{ stockItem.name || '-' }}</td>
              <td>{{ stockItem.unit }}</td>
              <td>{{ stockItem.stock || 'Tidak Ada Stok' }}</td>
              <td>{{ getRemainingStock(stockItem) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else>
        <p class="text-center text-muted">Tidak ada bahan untuk treatment ini.</p>
      </div>

      <div v-if="totalPages > 1" class="d-flex justify-content-between mt-3">
        <button @click="prevPage" :disabled="currentPage === 1" class="btn btn-sm btn-light">Previous</button>
        <span class="text-xs">Halaman {{ currentPage }} dari {{ totalPages }}</span>
        <button @click="nextPage" :disabled="currentPage >= totalPages" class="btn btn-sm btn-light">Next</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: ["data"],
  data() {
    return {
      currentPage: 1,
      itemsPerPage: 3,
      stockData: [],
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.stockData.length / this.itemsPerPage);
    },
    paginatedMaterials() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.stockData.slice(start, start + this.itemsPerPage);
    },
  },
  methods: {
    async fetchStock() {
      if (!this.data || !this.data.accu_treatment_id) {
        console.error("accu_treatment_id is missing", this.data);
        return;
      }
      
      try {
        const response = await axios.get("/kfs-inventory/ingredients/by-treatment", {
          params: { "where[accuTreatmentId]": this.data.accu_treatment_id },
        });

        if (response.data?.success && Array.isArray(response.data.data)) {
          this.stockData = response.data.data;
        } else {
          console.error("Invalid API response", response.data);
          this.stockData = [];
        }
      } catch (error) {
        console.error("Error fetching stock:", error);
        this.stockData = [];
      }
    },

    getRemainingStock(stockItem) {
      if (!stockItem.stock || !stockItem.netto || !stockItem.unit) return "Data Tidak Lengkap";

      const unitValue = parseFloat(stockItem.unit);
      if (isNaN(unitValue)) return "Unit Tidak Valid";

      const totalStock = stockItem.stock * stockItem.netto;
      let remainingUsageCount = Math.floor(totalStock / unitValue);

      return remainingUsageCount > 0 ? `${totalStock}` : "Habis";
    },

    nextPage() {
      if (this.currentPage < this.totalPages) this.currentPage++;
    },
    prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    },
  },
  mounted() {
    this.fetchStock();
  },
};
</script>

<style scoped>
#detail-treatment {
  max-width: 600px;
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}
.table th, .table td {
  text-align: center;
  padding: 8px;
}
.text-success {
  color: green;
}
.text-danger {
  color: red;
}
</style>
